import React, {useEffect, useState} from 'react';
import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody, Link} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import YtdReport from '../../../types/reports/ytdReport';

interface Props {
   reports?:YtdReport[];
}

interface Race {
    raceName: string;
    filers: YtdReport[];
}

//Todo: add the export link, and link to the filer reports page

const LegislativeRaceTable = (props: Props): JSX.Element => {

 const [raceData, setRaceData] = useState<Race[]>();

 useEffect(() => {
    if(props.reports){
        let reports = props.reports;
        let races: Race[] = [];
        reports.forEach((report: YtdReport) => {
          let officeSought = report.officeSought;
          let groupIndex = races.findIndex((race) => race.raceName === officeSought);
          if (groupIndex> -1){
              races[groupIndex].filers.push(report);
          }else{
              races.push({
              raceName: report.officeSought,
              filers: [report]
            });
          }
        })
        setRaceData(races);
    }
 }, [props.reports])

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper}>
             <Table stickyHeader aria-label="legislative race data" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Office / Name
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Party
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Incumbent
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Winner
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Receipts YTD	
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Expenditures YTD	
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Cash on Hand		
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Reported As		
                             </Typography>
                         </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {raceData?.map((race: Race, i) => (
                         <>
                            <TableRow key={i} sx={{ bgcolor: 'alternate.dark' }}>
                                <TableCell colSpan={8}>
                                    <Typography variant={'subtitle1'} fontWeight={650}>{race.raceName}</Typography>
                                </TableCell>
                            </TableRow>
                            {
                                race.filers.map((report: YtdReport, j) => (
                                    <TableRow
                                    key={j}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                    }}
                                    >
                                        <TableCell>
                                            <Typography variant={'subtitle2'} component={Link} underline="hover" href={`/filers?q=${report.cpfId}`} >
                                                {report.cpfId} {report.filerName}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {report.partyAffiliation}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {
                                                report.districtCodeHeld>0 && 
                                                <CheckIcon titleAccess="Incumbent" color="success" />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {
                                                report.isWinner && 
                                                <CheckIcon titleAccess="Winner" color="success" />
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'} component={Link} underline="hover" href={`/filers?q=${report.cpfId}&section=Contributions`}>
                                                {report.receiptsYtd}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'} component={Link} underline="hover" href={`/filers?q=${report.cpfId}&section=Expenditures`}>
                                                {report.expendituresYtd}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'} component={Link} underline="hover" href={`/reports/displayreport?id=${report.bankReportId}`}>
                                                {report.currentCashOnHand}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography variant={'subtitle2'}>
                                                {report.bankReportEndDate}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>

                                ))
                            }
                         </>  
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default LegislativeRaceTable;